import { TAB_STATUSES } from "@/constants/index.js";
import type { VisualBuilderModeResult } from "@/store/v2/visualBuilderData/types";
import { getVisualBuilderMode } from "@/utils/visualBuilder";

export interface UrlParams {
  experienceId?: string | number;
  mediaItemId?: string | number;
  asset?: string | number;
  page?: string;
  propertyId?: string | number | null;
  root?: string;
  shareId?: string | null;
  tabStatus?: string;
  userId?: string | number;
  organizationId?: string | null;
  menuPinned?: boolean;
}

interface ParsedParams extends UrlParams {
  mode?: string;
  vbKey?: string;
}

function findPage(paths: string[], root: string) {
  const isPublicViewer = paths.find((path) => path === "public-viewer");
  const isAllAssetsShare = paths.find((path) => path === "all-assets-share");
  const isSingleAssetShare = paths.find((path) => path === "media");

  if (isPublicViewer && isAllAssetsShare) {
    return "public-viewer-all-assets-share";
  } else if (isSingleAssetShare) {
    return "public-viewer-single-asset-share";
  } else if (root === "organizations") {
    return paths[5];
  } else {
    return paths[2];
  }
}

export default function parseParams(params: UrlParams, pathname: string): ParsedParams {
  const paths = pathname.split("/").filter((item) => !!item);
  const root = paths[0];
  const page = findPage(paths, root);

  const newParams: Partial<ParsedParams> = { ...params, root, page: page || "" };
  const menuPinned = !!parseInt(new URLSearchParams(window.location.search).get("menu") ?? "0", 10);

  if (newParams.propertyId === "create") {
    newParams.propertyId = null;
  }

  if (root === "properties" && newParams.propertyId) {
    if (newParams.experienceId) {
      const [, , , , tabStatus] = paths;
      newParams.tabStatus = tabStatus || TAB_STATUSES.PUBLIC;
      newParams.menuPinned = menuPinned;
      // Parse asset parameter for experience URLs
      const asset = new URLSearchParams(window.location.search).get("asset");
      newParams.asset = asset || undefined;
    } else if (page === "all-assets-share" || page === "public-viewer-all-assets-share") {
      newParams.tabStatus = TAB_STATUSES.PUBLIC_MEDIA_SHARE;
      newParams.shareId = new URLSearchParams(window.location.search).get("shareId");
      const asset = new URLSearchParams(window.location.search).get("asset");
      newParams.asset = asset || undefined;
      newParams.menuPinned = menuPinned;
    } else if (page === "single-asset-share") {
      newParams.tabStatus = TAB_STATUSES.PUBLIC_SINGLE_SHARE;
      newParams.shareId = new URLSearchParams(window.location.search).get("shareId");
      newParams.menuPinned = menuPinned;
    } else if (!page) {
      newParams.tabStatus = TAB_STATUSES.HOMEBASE;
    }
  }

  if (root === "organizations" && newParams.propertyId) {
    const [, , , , , , tabStatus] = paths;
    if (newParams.experienceId) {
      newParams.tabStatus = tabStatus || TAB_STATUSES.PUBLIC;
      // Parse asset parameter for organization experience URLs
      const asset = new URLSearchParams(window.location.search).get("asset");
      newParams.asset = asset || undefined;
    } else if (!page) {
      newParams.tabStatus = TAB_STATUSES.HOMEBASE;
    }
  }

  if (root === "profile") {
    newParams.propertyId = null;
  }

  if (newParams.tabStatus) {
    const { key, mode } = getVisualBuilderMode(newParams) as VisualBuilderModeResult;
    newParams.vbKey = key;
    newParams.mode = mode;
  }

  if (newParams.propertyId && !Number.isNaN(+newParams.propertyId)) {
    newParams.propertyId = +newParams.propertyId;
  }

  if (newParams.mediaItemId && !Number.isNaN(+newParams.mediaItemId)) {
    newParams.mediaItemId = +newParams.mediaItemId;
  }

  if (newParams.experienceId && !Number.isNaN(+newParams.experienceId)) {
    newParams.experienceId = +newParams.experienceId;
  }

  if (newParams.asset && !Number.isNaN(+newParams.asset)) {
    newParams.asset = +newParams.asset;
  }

  return newParams;
}
